import RadioGroup from "@mui/material/RadioGroup";

import { colors } from "@dotnet/telematics-design-system";

import Radio from "components/DesignComponents/Radio";
import { body2SemiBold, fileFormatBlockStyle } from "shared";

import { DeviceRadioGroupProps } from "../types";

const DeviceRadioGroup = ({
    title,
    target,
    firstRadioLabel,
    firstRadioValue,
    secondRadioLabel,
    secondRadioValue,
    isLoading,
    onChange,
    customStyle
}: DeviceRadioGroupProps) => {
    const { gray700 } = colors;

    return (
        <>
            <div css={[body2SemiBold, { color: gray700, marginBottom: "4px" }]}>
                {title}
            </div>

            <RadioGroup
                value={target}
                onChange={onChange}
                sx={customStyle || fileFormatBlockStyle}
            >
                <Radio
                    value={firstRadioValue}
                    label={firstRadioLabel}
                    disabled={isLoading}
                />

                <Radio
                    value={secondRadioValue}
                    label={secondRadioLabel}
                    disabled={isLoading}
                />
            </RadioGroup>
        </>
    );
};

export default DeviceRadioGroup;
